import React, { useState, useContext, useEffect } from 'react';
import { Button, Form, FormGroup, Row, Col, Label, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import Alert from 'react-s-alert';

// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// import services
import GeneralService from '../../services/GeneralService';

// local imports
import Footer from '../general/Footer';
import listOfStates from '../../assets/listOfStates.json';
import listOfCities from '../../assets/listOfCities.json';
import Message from '../general/Message';

const ClientSignUpStep1 = props => {

    // contexts
    const { theme, colors, fontFamily, fontSize, fontWeight } = useContext(ThemeContext);
    const { user, setUser } = useContext(AuthContext);

    // states
    const [client, setClient] = useState({});
    const [titles, setTitles] = useState([]);
    const [filteredCities, setFilteredCities] = useState(listOfCities);
    const [isError, setIsError] = useState({
        message: {
            msgBody: "",
            msgError: false
        }
    });

    // useEffects
    useEffect(() => {
        window.scrollTo(0, 0);
        const temp = user.username.trim().split(' ');
        // console.log(temp)
        setClient({
            ...client,
            firstName: temp[0],
            lastName: temp[1],
            email: user.email,
            country: 'India'
        })
    }, [])

    useEffect(() => {
        if (isError.message.msgError) {
            window.scrollTo(0, 0);
        }
    }, [isError.message]);

    useEffect(() => {
        GeneralService.getProfileSuggestions()
            .then(data => {
                try {
                    setTitles(data.userTitles);
                } catch (err) {
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    // GeneralService.logError('at Client ClientProfile useEffect', 'Error in try catch block', err.stack);
                }
            });
    }, []);

    const handleChange = e => {
        try {
            setClient({ ...client, [e.target.name]: e.target.value });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Client ClientProfile handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleCityChange = e => {
        try {
            if (e.target.selectedIndex == 0) {
                document.getElementById("state").selectedIndex = 0;
            } else {
                const index = e.target.selectedIndex - 1;
                const stateIndex = Number(filteredCities[index].state_id);
                document.getElementById("state").selectedIndex = stateIndex;
                setClient({ ...client, city: filteredCities[index].name });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Client ClientProfile handleCityChange', 'Error in try catch block', err.stack);
        }
    }

    const handleStateChange = e => {
        try {
            if (e.target.selectedIndex == 0) {
                setFilteredCities(listOfCities);
            } else {
                const index = e.target.selectedIndex - 1;
                setFilteredCities(listOfCities.filter(item => item.state_id == listOfStates[index].id));
                setClient({ ...client, state: listOfStates[index].name });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Client ClientProfile handleStateChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            if (!client.title) {
                setIsError({ message: { msgBody: "Please select title", msgError: true } });
            } else if (!client.firstName) {
                setIsError({ message: { msgBody: "Please enter firstname", msgError: true } });
            } else if (!client.lastName) {
                setIsError({ message: { msgBody: "Please enter lastname", msgError: true } });
            } else if (!client.gender) {
                setIsError({ message: { msgBody: "Please select gender", msgError: true } });
            } else if (!client.address1) {
                setIsError({ message: { msgBody: "Please enter address1", msgError: true } });
            } else if (!client.address2) {
                setIsError({ message: { msgBody: "Please enter address2", msgError: true } });
            } else if (!client.city) {
                setIsError({ message: { msgBody: "Please select city", msgError: true } });
            } else if (!client.state) {
                setIsError({ message: { msgBody: "Please select state", msgError: true } });
            } else if (!client.pincode) {
                setIsError({ message: { msgBody: "Please enter pincode", msgError: true } });
            } else {
                props.history.push({
                    pathname: "/client/signup-step2",
                    state: {
                        client: client,
                    }
                });
            }
        } catch (err) {
            console.log('err', err)
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // setIsLoading2(false);
            // GeneralService.logError('at Client ClientProfile handleSubmit', 'Error in try catch block', err.stack);
        }
    }

    // function's return
    return (
        <div>

            <h1 className='mt-5 pl-4' style={theme.headingMedium}>Client Signup</h1>

            <div className='mt-5 mb-5 row'>

                <div className='col-md-3 col-12' style={{ borderRight: "solid 1px", borderColor: "#C0C0C0" }}>
                    <ol>
                        <li id="client-signup-fill-info" className='mt-2' style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md_sm, fontWeight: fontWeight.semiBold }}>Fill in your Information</li>
                        <li id="client-signup-reviewandsubmit" className='mt-2' style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md_sm }}>Review and Submit</li>
                    </ol>
                </div>

                <div className='col-md-9 col-12'>
                    <h2 id="fill-info-heading" style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md, fontWeight: fontWeight.semiBold }}>Fill in your Information</h2>
                    <hr style={{ color: "#C0C0C0", borderWidth: "2px" }} />

                    {isError.message.msgError ? <div className='mt-5'><Message message={isError.message} /></div> : null}

                    <Form className='mt-5' style={{ maxWidth: "60%" }}>
                        <FormGroup>
                            <Label id="form-title" for="title" style={theme.formBodyText}>Title</Label>
                            <Input type="select" name="title" id="title" style={theme.formInput} onChange={handleChange} defaultValue={""} value={client.title} required>
                                <option value="">Select one</option>
                                {
                                    titles.map((item, index) => (
                                        <option key={index} value={item}>{item}</option>
                                    ))
                                }
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label id="form-firstname" for="firstName" style={theme.formBodyText}>First Name</Label>
                            <Input type="text" name="firstName" id="firstName" style={theme.formInput} onChange={handleChange} value={client.firstName} required />
                        </FormGroup>

                        <FormGroup>
                            <Label id="form-lastname" for="lastName" style={theme.formBodyText}>Last Name</Label>
                            <Input type="text" name="lastName" id="lastName" style={theme.formInput} onChange={handleChange} value={client.lastName} required />
                        </FormGroup>

                        <FormGroup>
                            <Label id="form-email" for="email" style={theme.formBodyText}>Email</Label>
                            <Input type="email" name="email" id="email" value={client.email} disabled style={theme.formInput} />
                        </FormGroup>

                        <FormGroup row className="ml-0">
                            <legend id="form-gender" style={theme.formBodyText}>Gender</legend>
                            <FormGroup check>
                                <Label check>
                                    <Input id="male" type="radio" name="gender" value="male" onChange={handleChange} checked={client.gender == "male" ? true : false} />{' '}
                                    Male
                                </Label>
                            </FormGroup>
                            <FormGroup className="ml-3" check>
                                <Label check>
                                    <Input id="female" type="radio" name="gender" value="female" onChange={handleChange} checked={client.gender == "female" ? true : false} />{' '}
                                    Female
                                </Label>
                            </FormGroup>
                        </FormGroup>

                        <FormGroup>
                            <Label id="form-address" for="address1" style={theme.formBodyText}>Address</Label>
                            <Input type="text" style={theme.formInput} name="address1" id="address1" placeholder="Flat, House no. Building, Company, Apartment" onChange={handleChange} value={client.address1} required />
                        </FormGroup>
                        <FormGroup>
                            <Label id="form-address2" for="address2" style={theme.formBodyText}>Address 2</Label>
                            <Input type="text" style={theme.formInput} name="address2" id="address2" placeholder="Area, Colony, Street, Sector, Village" onChange={handleChange} value={client.address2} required />
                        </FormGroup>
                        <Row form>
                            <Col md={4}>
                                <FormGroup>
                                    <Label id="form-state" for="state" style={theme.formBodyText}>State</Label>
                                    <Input type="select" id="state" name="state" style={theme.formInput} onChange={handleStateChange} value={client.state} required>
                                        <option value="">Select</option>
                                        {
                                            listOfStates.map((item) => (
                                                <option key={item.id} value={item.name}>{item.name}</option>
                                            ))
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={5}>
                                <FormGroup>
                                    <Label id="form-city" for="city" style={theme.formBodyText}>City</Label>
                                    <Input type="select" id="city" name="city" style={theme.formInput} onChange={handleCityChange} value={client.city} required>
                                        <option value="">Select</option>
                                        {
                                            filteredCities.map((item) => (
                                                <option key={item.id} value={item.name}>{item.name}</option>
                                            ))
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Label id="form-pincode" for="Pincode" style={theme.formBodyText}>Pincode</Label>
                                    <Input type="text" style={theme.formInput} name="pincode" id="pincode" placeholder="123456" onChange={handleChange} value={client.pincode} required />
                                </FormGroup>
                            </Col>
                        </Row>

                        <FormGroup>
                            <Label id="form-country" for="country" style={theme.formBodyText}>Country</Label>
                            <Input type="text" name="country" id="country" disabled value={client.country} style={theme.formInput} required />
                        </FormGroup>
                    </Form>

                    <p id="nextbtn" className='mt-5 mb-0 float-right mr-5' style={{ fontFamily: fontFamily.primary, color: colors.primary, fontSize: fontSize.lg, cursor: 'pointer' }} onClick={(e) => handleSubmit(e)}>Next <i className="fas fa-arrow-circle-right"></i></p>

                </div>

            </div>


            <Footer />

        </div>
    )
}

export default ClientSignUpStep1;